import IconBase from "../IconBase";

const ExchangeIcon = (props) => {
  return (
    <IconBase {...props}>
      <path
        d="M3.52997 11.47V13.588C3.52984 14.1443 3.63928 14.6951 3.85205 15.209C4.06482 15.7229 4.37675 16.1899 4.77002 16.5833C5.16329 16.9766 5.63019 17.2887 6.14407 17.5016C6.65795 17.7145 7.20874 17.824 7.76497 17.824H20.47M3.52997 6.17603H16.235C16.7913 6.17589 17.3422 6.28537 17.8562 6.4982C18.3702 6.71104 18.8372 7.02305 19.2306 7.41643C19.6239 7.8098 19.936 8.27683 20.1488 8.79082C20.3616 9.30482 20.4711 9.85571 20.471 10.412V12.529"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M17.294 14.647L20.471 17.823L17.294 21M6.70599 9.353L3.52899 6.176L6.70599 3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  );
};

export default ExchangeIcon;
